// extracted by mini-css-extract-plugin
export default {"onDarkBackground":"Link__onDarkBackground","display-block":"Link__display-block","extraTopMargin":"Link__extraTopMargin"};